import { useState } from 'react';

import { MuiChipsInput } from 'mui-chips-input';
import { Controller, useFormContext } from 'react-hook-form';
import { IP_REGEX } from 'shared/react-admin/Inputs/TextInputs/IpAddressInput/constants/constants';

const filterIpChars = (value: string): string => value.replace(/[^\d.]/g, '');

export const ProvidersShowWhiteIpAddressesMultipleIpInput: React.FC = () => {
  const { control } = useFormContext();
  const [inputValue, setInputValue] = useState('');

  return (
    <Controller
      control={control}
      defaultValue={[]}
      name="ip"
      render={({ field, fieldState }) => (
        <MuiChipsInput
          InputLabelProps={{ shrink: true }}
          addOnWhichKey={[' ', 'Enter']}
          fullWidth
          helperText={fieldState.error?.message ?? ' '}
          label="IP"
          placeholder="Введите IP в формате 000.000.000.000 и нажмите Enter"
          size="small"
          {...field}
          error={fieldState.invalid}
          hideClearAll
          inputValue={inputValue}
          onInputChange={(value) => setInputValue(filterIpChars(value))}
          onPaste={(event) => {
            event.preventDefault();
            const pastedIps = event.clipboardData
              .getData('Text')
              .split(/[\s,;]+/)
              .map(filterIpChars)
              .filter((ip) => IP_REGEX.test(ip));
            if (pastedIps.length) {
              field.onChange([...(field.value ?? []), ...pastedIps]);
            }
          }}
          validate={(chipValue) => ({
            isError: !IP_REGEX.test(chipValue),
            textError: 'Введите корректный IP-адрес',
          })}
          variant="outlined"
        />
      )}
      rules={{
        validate: (value) => (Array.isArray(value) && value.length > 0) || 'Обязательное поле',
      }}
    />
  );
};
